import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { getToken } from './api';
import LoginPage from './pages/LoginPage';
import ClusterOverviewPage from './pages/ClusterOverviewPage';
import TenantsListPage from './pages/TenantsListPage';
import TenantDetailPage from './pages/TenantDetailPage';
import TableDetailPage from './pages/TableDetailPage';
import SyncControlPage from './pages/SyncControlPage';
import SyncLogsPage from './pages/SyncLogsPage';
import SyncStatePage from './pages/SyncStatePage';
import OutboxPage from './pages/OutboxPage';
import WebhooksPage from './pages/WebhooksPage';
import AuditGlobalPage from './pages/AuditGlobalPage';
import IntegrationsPage from './pages/IntegrationsPage';
import ExternalAccessPage from './pages/ExternalAccessPage';

function Protected({ children }: { children: React.ReactNode }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Navigate to="/cluster" replace />} />

      <Route path="/cluster" element={<Protected><ClusterOverviewPage /></Protected>} />
      <Route path="/tenants" element={<Protected><TenantsListPage /></Protected>} />
      <Route path="/tenants/:tenantCode" element={<Protected><TenantDetailPage /></Protected>} />
      <Route path="/tenants/:tenantCode/integrations" element={<Protected><IntegrationsPage /></Protected>} />
      <Route path="/tenants/:tenantCode/db/:schema/:table" element={<Protected><TableDetailPage /></Protected>} />

      <Route path="/operations/sync-control" element={<Protected><SyncControlPage /></Protected>} />
      <Route path="/operations/sync-logs" element={<Protected><SyncLogsPage /></Protected>} />
      <Route path="/operations/sync-state" element={<Protected><SyncStatePage /></Protected>} />
      <Route path="/operations/outbox" element={<Protected><OutboxPage /></Protected>} />
      <Route path="/operations/webhooks" element={<Protected><WebhooksPage /></Protected>} />
      <Route path="/external-access" element={<Protected><ExternalAccessPage /></Protected>} />

      <Route path="/audit" element={<Protected><AuditGlobalPage /></Protected>} />

      <Route path="*" element={<Navigate to="/cluster" replace />} />
    </Routes>
  );
}
